"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModulePageList = void 0;
var ModulePageList_1 = require("./ModulePageList");
Object.defineProperty(exports, "ModulePageList", { enumerable: true, get: function () { return __importDefault(ModulePageList_1).default; } });
